import script from "./FormPayPlanesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormPayPlanesComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormPayPlanesComponent.vue?vue&type=style&index=0&id=0200a051&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0200a051"]])

export default __exports__